import React, { Component } from "react";
import { connect } from "react-redux";
import { ActiveStep } from "./";
import {
  abandonContract,
  clearStore,
  createContract,
  fetchContract,
} from "../duck/id";
import { setInitLoading } from "../duck/basic";
import { Button } from "semantic-ui-react";
import {
  Abandon,
  ButtonNav,
  ErrorView,
  Instructions,
  LoadingView,
  Nav,
  Prefiller,
  RemoteSuccess,
  Success,
  Warning,
} from "../components";

class BuilderContainer extends Component {
  state = {
    showAbandon: false,
  };

  componentDidMount = () => {
    if (this.props.contractId) {
      this.props.dispatch(fetchContract(this.props.contractId, "systems"));
    } else {
      this.props.dispatch(createContract());
      // this.props.dispatch(setInitLoading(false))
    }
  };

  componentWillUnmount = () => {
    this.props.dispatch(clearStore());
  };

  onAbandon = (note) => {
    // e.preventDefault();

    this.props.dispatch(abandonContract(this.props.id, note));
  };

  toggleAbandon = (e) => {
    e ? e.preventDefault() : null;
    this.setState({ showAbandon: !this.state.showAbandon });
  };

  render() {
    const { id, renter } = this.props;

    if (this.props.initLoading) {
      return <LoadingView />;
    }

    if (this.props.status == 8) {
      return (
        <Warning
          color="red"
          icon="ban"
          header="Abandoned Contract"
          subheader="The contract you requested has been abandoned!"
          showButton={false}
        >
          <Button as="a" href="/dealer/contracts" content="Close" basic />
        </Warning>
      );
    }

    if (this.props.error) {
      return (
        <ErrorView
          message={this.props.error}
          hideClose={!this.props.id ? true : false}
        />
      );
    }

    if (this.props.showRemoteSuccess) {
      return <RemoteSuccess email={this.props.renter.email} />;
    }

    if (this.props.showSuccess) {
      return <Success id={id} />;
    }

    if (this.state.showAbandon) {
      return (
        <Abandon onClose={this.toggleAbandon} onConfirm={this.onAbandon} />
      );
    }

    return (
      <div>
        {this.props.loading && <LoadingView />}
        {["dev", "qa"].includes(process.env.ENV) &&
          this.props.id &&
          this.props.renter.id && <Prefiller />}
        <Instructions />
        <Nav />
        <ActiveStep />
        <ButtonNav />
        {!this.props.payment && this.props.id && (
          <div style={{ textAlign: "center" }}>
            <Button
              basic
              style={{
                marginTop: "50px",
              }}
              onClick={this.toggleAbandon}
              content="Abandon Contract"
            />
          </div>
        )}
        {!this.props.payment &&
          !this.props.id &&
          !this.props.loading &&
          this.props.onClose && (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                marginTop: "50px",
              }}
            >
              <Button onClick={this.props.onClose} content="Close" basic />
            </div>
          )}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    activeStep: state.activeStep,
    id: state.id,
    initLoading: state.initLoading,
    error: state.error,
    loading: state.loading,
    payment: state.payment,
    renter: state.renter,
    showRemoteSuccess: state.showRemoteSuccess,
    showSuccess: state.showSuccess,
    status: state.status,
  };
}

export default connect(mapStateToProps)(BuilderContainer);
